import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Notifications from '@/app/module/notifications'
import Plans from '@/app/module/plans'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps
}

export default function PlansPage({ match }: Props) {
  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Plans - engageSPARK">
        <AuthHeader currentPage={PAGE.PLANS.INDEX} />
        <TotpGuard>
          <Plans />
        </TotpGuard>
      </Layout>
      <Notifications />
    </AuthGuard>
  )
}
